module.exports = __webpack_public_path__ + "img/money.1c586800.png";